import type { Lang } from '@/context/i18n'

const EMPTY = ''

function hasContent(value: unknown) {
  if (value === null || value === undefined) return false
  if (typeof value === 'string') return value.trim().length > 0
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'object') return true
  return true
}

export function pickLocalized<T = string | undefined>(
  lang: Lang,
  base: T,
  en?: T,
  fr?: T,
  opts?: { fallbackTo?: 'en' | 'fr' | 'base'; }
): T {
  if (lang === 'EN' && hasContent(en)) return en as T
  if (lang === 'FR' && hasContent(fr)) return fr as T

  if (lang === 'FR' && !hasContent(fr)) {
    if (opts?.fallbackTo === 'en' && hasContent(en)) return en as T
  }
  if (lang === 'EN' && !hasContent(en)) {
    if (opts?.fallbackTo === 'fr' && hasContent(fr)) return fr as T
  }

  if (hasContent(base)) return base
  if (hasContent(en)) return en as T
  if (hasContent(fr)) return fr as T

  return (EMPTY as T)
}

export function pickLocalizedRich(
  lang: Lang,
  base: string | undefined,
  en?: string,
  fr?: string
) {
  return pickLocalized(lang, base, en, fr)
}

export function pickLocalizedArray<T>(
  lang: Lang,
  base: T[] | undefined,
  en?: T[],
  fr?: T[]
): T[] | undefined {
  return pickLocalized<T[] | undefined>(lang, base, en, fr)
}
